// Vue & Plugins
import { computed } from 'vue'
import { useAuthSiteStore } from '../../user/authSiteStore'
import { storeToRefs } from 'pinia'
import { singular as pluralizeSingular, plural as pluralizePlural } from 'pluralize'

export type ResourceTerm = 'areas' | 'buildings' | 'skills' | 'skill_types'

export const ResourceKeys = {
    EMPLOYEE: 'employees',

    AVAILABILITY: 'availability',

    AREA: 'areas',
    BUILDING: 'buildings',

    SKILL: 'skills',
    SKILL_TYPE: 'skill_types',
}

export function useResourceNames() {
    const authSiteStore = useAuthSiteStore()
    const {
        terms,
    } = storeToRefs(authSiteStore)
    const getTerm = (key: string) => computed(() => !terms.value ? key : (terms.value[key] ?? key.replace(/_/g, ' ')))
    const getSingular = (key: string) => computed(() => pluralizeSingular(!terms.value ? key : (terms.value[key] ?? key.replace(/_/g, ' '))))
    const getPlural = (key: string) => computed(() => pluralizePlural(!terms.value ? key : (terms.value[key] ?? key.replace(/_/g, ' '))))

    return {
        getTerm,
        getSingular,
        getPlural,
    }
}

export function useResourceLabel(resourceTerm: ResourceTerm) {
    const authSiteStore = useAuthSiteStore()
    const { terms } = storeToRefs(authSiteStore)
    
    const term = computed(() => !terms.value ? resourceTerm : (terms.value[resourceTerm] ?? resourceTerm.replace(/_/g, ' ')))
    const singular = computed(() => pluralizeSingular(!terms.value ? resourceTerm : (terms.value[resourceTerm] ?? resourceTerm.replace(/_/g, ' '))))
    const plural = computed(() => pluralizePlural(!terms.value ? resourceTerm : (terms.value[resourceTerm] ?? resourceTerm.replace(/_/g, ' '))))

    return {
        term,
        singular,
        plural,
    }
}
